import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogRef } from '../../../core/services/dialog.service';
import { ToastService } from '../../../core/services/toast.service';
import { PatientsService } from '../../services/patients.service';
import { AppInput } from '../app-input/app-input';
import { AppSelect } from '../app-select/app-select';
import { AppButton } from '../app-button/app-button';
import { pastDateValidator } from '../../validators/past-date.validator';

@Component({
    selector: 'app-quick-patient-dialog',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, AppInput, AppSelect, AppButton],
    templateUrl: './quick-patient-dialog.html'
})
export class QuickPatientDialog {
    private dialogRef = inject(DialogRef);
    private fb = inject(FormBuilder);
    private patientsService = inject(PatientsService);
    private toast = inject(ToastService);

    loading = signal(false);

    patientForm = this.fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        identification: [''],
        identificationType: ['CEDULA'],
        phone: [''],
        email: ['', [Validators.email]],
        birthDate: ['', [pastDateValidator]],
        address: [''],
        gender: ['O']
    });

    idTypeOptions = [
        { label: 'Cédula', value: 'CEDULA' },
        { label: 'RUC', value: 'RUC' },
        { label: 'Pasaporte', value: 'PASAPORTE' }
    ];

    gendersOptions = [
        { label: 'Masculino', value: 'M' },
        { label: 'Femenino', value: 'F' },
        { label: 'Otro', value: 'O' }
    ];

    createQuickPatient() {
        if (this.patientForm.invalid) return;

        this.loading.set(true);

        this.patientsService.create(this.patientForm.value as any).subscribe({
            next: (response: any) => {
                this.loading.set(false);
                const newPatient = response?.data || response;
                this.toast.show('Éxito', 'Paciente creado correctamente', 'success');
                this.dialogRef.close({ action: 'create_patient_success', patient: newPatient });
            },
            error: (err) => {
                this.loading.set(false);
            }
        });
    }

    close() {
        this.dialogRef.close();
    }
}
